import $ from 'jquery'
import { getArgsByGetParams } from './helpers'


const apiFormBehavior = () => {

    const apiForm = document.querySelector('.api-form')
    const apiFormFirstElement = apiForm ? apiForm.querySelector('.accordion__content') : null
    const $topics = $('.search-field__topic')
    const $plus = $('.plus')

    if (!apiForm)
        return

    // open the first one
    //$(apiFormFirstElement).slideDown()

    stylefields()

    openFieldsOptions()

    handleGroups()

    apiSearchNext(apiForm)

    fillInputs(apiForm)

}

export default apiFormBehavior




// hendle and style group when clicking on children 
const stylefields = () => {

    const checkboxes = Array.from(document.querySelectorAll('.search-field__service'))

    checkboxes.forEach(el => {

        el.addEventListener('click', function (e) {

            const $parent = $(this).parents('.search-field__options')
            const $head = $parent.prev('.search-field__head')
            const group = $(this).parents('.search-field').find('.search-field__service-group')[0]
            const $topic = $head.children('.search-field__topic')

            const checkboxes = Array.from($parent[0].querySelectorAll('.search-field__service'))

            const allChecked = checkboxes.every(el => el.checked)
            const someChecked = checkboxes.some(el => el.checked)


            if (allChecked) {

                $head[0].classList.add('search-field__head--all')
                $head[0].classList.remove('search-field__head--none', 'search-field__head--some')
                group.checked = true
            } else if (someChecked) {

                $head[0].classList.add('search-field__head--some')
                $head[0].classList.remove('search-field__head--none', 'search-field__head--all')
                group.checked = false
            } else {

                $head[0].classList.add('search-field__head--none')
                $head[0].classList.remove('search-field__head--all', 'search-field__head--some')
                group.checked = false
            }

        })
    })

}

// hendle and style group when clicking on group checkbox 
const handleGroups = () => {

    const groups = Array.from(document.querySelectorAll('.search-field__service-group'))
    groups.forEach(el => {
        el.addEventListener('click', function (e) {

            const children = Array.from($(el).parents('.search-field')[0].querySelectorAll('.search-field__service'))
            //const $parent = $(this).parents('.search-field__options')
            const $head = $(this).parents('.search-field__head')
            const allChecked = children.length > 0 && children.every(el => el.checked)
            const someChecked = children.some(el => el.checked)

            if (allChecked) {
                children.forEach(el => el.checked = false)
                this.checked = false
                $head.removeClass('search-field__head--all')
            } else if (someChecked) {
                children.forEach(el => el.checked = true)
                this.checked = true
                $head.removeClass('search-field__head--some')
            }
            else {
                this.checked = true
                children.forEach(el => el.checked = true)
                $head.removeClass('search-field__head--some')
            }
        })
    })
}

// handle the openning and closing options fields accordion
const openFieldsOptions = () => {
    $('.search-field__options').show().hide()

    const $openBy = $('.search-field--open')
    $openBy.on('click', function (e) {

        const elToOpen = $(this).parents('.search-field').children('.search-field__options')

        const $plusSign = elToOpen.prev('.search-field__head').find('.plus-sign')
        const $minusSign = elToOpen.prev('.search-field__head').find('.minus-sign')

        $plusSign.toggleClass('plus-sign--active')
        $minusSign.toggleClass('minus-sign--active')

        elToOpen.slideToggle()
    })

}

// api search next button
const apiSearchNext = apiForm => {
    const btns = document.querySelectorAll('.api-btn-next')
    btns.forEach(btn => {
        btn.addEventListener('click', function (e) {
            const $parent = $(this).parents('.api-search--element')
            $(this).parents('.accordion__element').find('.accordion__title').find('.plus-sign').addClass('plus-sign--active')
            $(this).parents('.accordion__element').find('.accordion__title').find('.minus-sign').removeClass('minus-sign--active')

            // close this one
            $parent.find('.accordion__content').slideUp()

            // open next
            $parent.next('.api-search--element').find('.accordion__content').slideDown()
            $parent.next('.api-search--element').find('.accordion__title').find('.plus-sign').removeClass('plus-sign--active')
            $parent.next('.api-search--element').find('.accordion__title').find('.minus-sign').addClass('minus-sign--active')
        })
    })

    // change btn text

    const inputs = apiForm.querySelectorAll('input')
    const selects = apiForm.querySelectorAll('select')


    inputs.forEach(input => input.addEventListener('input', changeText))
    selects.forEach(input => input.addEventListener('input', changeText))

    function changeText(e) {

        const newText = 'הבא'
        const btn = $(this).parents('.api-search--element').find('.api-btn-next')[0]

        btn && (btn.innerText = newText)


    }
}

// fill the inputs if have get parameters
const fillInputs = apiForm => {
    const getSearchArgs = getArgsByGetParams()

    if (!getSearchArgs)
        return null

    const inputs = apiForm.querySelectorAll('input')
    const selects = apiForm.querySelectorAll('select')
    const restInputs = apiForm.querySelectorAll('.search-rest input')
    const textInput = apiForm.querySelector('.search-free-text__input')
    const selectInputs = apiForm.querySelectorAll('select')
    const fieldsInputs = apiForm.querySelectorAll('.search-fields input')

    // rest inputs handler
    restInputs.forEach(input => {
        for (let arg in getSearchArgs) {

            if (arg === input.name) {
                if (input.type === 'checkbox' && getSearchArgs[arg] && getSearchArgs[arg] !== '0') {
                    input.checked = true
                }
                if (input.type === 'radio' && input.value === getSearchArgs[arg]) {
                    input.checked = true
                }
            }
        }
    })
    // free search handler
    if (getSearchArgs['Text']) {
        textInput.value = getSearchArgs['Text']
    }

    //select inputs handler
    selectInputs.forEach(select => {
        const options = Array.from(select.querySelectorAll('option'))
        for (let arg in getSearchArgs) {
            if (select.name === arg && getSearchArgs[arg]) {
                const option = options.filter(option => option.value && option.value === getSearchArgs[arg])[0]
                option && (option.selected = true)
            }
        }
    })

    // search fields handler
    {
        const values = getSearchArgs['Act'].split(',')
        if (values && values.length > 0) {
            fieldsInputs.forEach(input => {
                if (values.includes(input.value)) {
                    input.checked = true
                }
            })
        }

        function style() {

            const groups = apiForm.querySelectorAll('.search-field')
            groups.forEach(group => {
                const childs = Array.from(group.querySelectorAll('input'))

                if (childs.length) {
                    const some = childs.some(input => input.checked)
                    const every = childs.every(input => input.checked)
                    if (some && !every) {
                        const parent = group.querySelector('.search-field__head')
                        parent.classList.add('search-field__head--some')
                    }
                }
            })
        }

        style()
    }



}